var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("v-data-table", {
            attrs: {
              items: _vm.domainsItems,
              headers: _vm.headers,
              loading: _vm.loading,
              search: _vm.search
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function fn(_ref2) {
                                var on = _ref2.on,
                                  attrs = _ref2.attrs
                                return [
                                  _c(
                                    "gg-btn",
                                    _vm._g(
                                      _vm._b({}, "gg-btn", attrs, false),
                                      on
                                    ),
                                    [
                                      _vm._v(" Manage "),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-1"
                                        },
                                        [_vm._v("mdi-chevron-down")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.openModal("addRecord", {
                                      domain: item.domain,
                                      username: item.username,
                                      type: "A"
                                    })
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(" Add A record ")
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.openModal("addRecord", {
                                      domain: item.domain,
                                      username: item.username,
                                      type: "CNAME"
                                    })
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(" Add CNAME record ")
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.openModal("addRecord", {
                                      domain: item.domain,
                                      username: item.username,
                                      type: "MX"
                                    })
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(" Add MX record ")
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.showDetailsTable({
                                      domain: item.domain,
                                      username: item.username
                                    })
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(" Manage Records ")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.selectedItem
        ? _c("add-record-modal", {
            attrs: {
              opened: _vm.modals.addRecord,
              domain: _vm.selectedItem.domain,
              username: _vm.selectedItem.username,
              type: _vm.selectedItem.type
            },
            on: {
              "action-completed": _vm.recordAdded,
              close: function close($event) {
                return _vm.closeModal("addRecord")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }